export default class SimpleSearchController {
    /**
     * @param EventEmitter
     * @ngInject
     */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.isFocused = false;
    }

    triggerSearch() {
        this.onBeforeSearch();

        if (this.query.length) {
            this.triggerSearchResult();
        } else {
            this.onEmptySearch();
        }
    }

    focused() {
        this.isFocused = true;
        this.triggerFocusChange();
    }

    blurred() {
        if (this.addFocus) {
            this.addFocus = false;
            return;
        }

        this.isFocused = false;
        this.triggerFocusChange();
    }

    isInFocus() {
        return this.isFocused;
    }

    triggerFocusChange() {
        this.onFocusChange(
            this.eventEmitter({
                isFocused: this.isFocused
            })
        );
    }

    triggerSearchResult() {
        this.onSearchResult(
            this.eventEmitter({
                query: this.query
            })
        );
    }

    clearSearch() {
        this.query = '';
        this.searchThingForm.search.$rollbackViewValue();
        this.addFocus = true;
        this.onEmptySearch();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/simple/search.controller.js